import { Colors } from '@doordash/design-language';
import * as React from 'react';
import Cropper from 'react-easy-crop';
import SliderContainer from './SliderContainer';
import { CropContainer, CropControls, CropModalContentWrapper } from './styles';
export var CropperContainer = function (_a) {
    var aspect = _a.aspect, imgSrc = _a.imgSrc, isCircleCrop = _a.isCircleCrop, setCroppedAreaPixels = _a.setCroppedAreaPixels, min = _a.min, max = _a.max, step = _a.step, cropperWidth = _a.cropperWidth, cropperHeight = _a.cropperHeight, initialZoom = _a.initialZoom;
    var _b = React.useState({ x: 0, y: 0 }), crop = _b[0], setCrop = _b[1];
    var _c = React.useState(initialZoom), zoom = _c[0], setZoom = _c[1];
    var _d = React.useState(false), isSubtractDisabled = _d[0], setIsSubtractDisabled = _d[1];
    var _e = React.useState(false), isAddDisabled = _e[0], setIsAddDisabled = _e[1];
    var onCropComplete = React.useCallback(function (croppedArea, croppedAreaPixels) {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);
    var decrementZoom = function () {
        setZoom(Math.max(min, zoom - step));
    };
    var incrementZoom = function () {
        setZoom(Math.min(max, zoom + step));
    };
    var setAddSubtractIconDisabled = function () {
        setIsSubtractDisabled(zoom === min);
        setIsAddDisabled(zoom === max);
    };
    React.useEffect(function () {
        setAddSubtractIconDisabled();
    }, [zoom, initialZoom, max]);
    React.useEffect(function () {
        setZoom(initialZoom);
    }, [initialZoom]);
    return (React.createElement(CropModalContentWrapper, null,
        React.createElement(CropContainer, null,
            React.createElement(Cropper, { cropSize: { width: cropperWidth, height: cropperHeight }, image: imgSrc, crop: crop, zoom: zoom, aspect: aspect, onCropChange: setCrop, onCropComplete: onCropComplete, onZoomChange: setZoom, showGrid: false, cropShape: isCircleCrop ? 'round' : 'rect', style: {
                    cropAreaStyle: { color: Colors.SystemWhite, opacity: '90%' },
                } })),
        React.createElement(CropControls, null,
            React.createElement(SliderContainer, { min: min, max: max, value: zoom, step: step, onChange: setZoom, decrementZoom: decrementZoom, incrementZoom: incrementZoom, isSubtractDisabled: isSubtractDisabled, isAddDisabled: isAddDisabled }))));
};
